<div class="generate-documents-form-container">
  <div class="title-container">
    <h3>Authorisation</h3>
  </div>

  @if (authorisationModel) {
    <div class="form-body-container">
      <div class="document-type">
        <app-radio
          label="Choose the type of document to generate"
          [options]="documentTypeOptions"
          [ngModelOptions]="{standalone: true}"
          [(ngModel)]="authorisationModel.documentationType"
          (ngModelChange)="onDocumentationTypeChange()"
        />
      </div>

      @if (authorisationModel.documentationType === DocumentationType.Minutes) {
        <div class="d-flex gap-24">
          <div class="meeting-date">
            <app-date-picker
              label="Date Meeting was Held"
              [minDate]="minDateOfMeeting"
              [maxDate]="maxDateOfMeeting"
              [customErrors]="customDatepickerErrors"
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="authorisationModel.meetingDate"
              (ngModelChange)="onDisableHeaderBtn()"
            />
          </div>

          <div class="meeting-type">
            <app-select
              label="Type"
              placeholder="Select type"
              [valuePrimitive]="true"
              [options]="meetingTypeOptions"
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="authorisationModel.meetingAddressType"
              (ngModelChange)="onMeetingAddressTypeSelect($event)"
            />
          </div>
        </div>

        @if (authorisationModel.meetingAddressType === MeetingLocationTypeEnum.Online) {
          <div class="meeting-address">
            <app-select
              label="Communication Method"
              placeholder="Select Communication Method"
              [valuePrimitive]="true"
              [options]="meetingOnlineTypeOptions"
              [ngModelOptions]="{standalone: true}"
              [(ngModel)]="authorisationModel.meetingOnlineAddress"
              (ngModelChange)="onDisableHeaderBtn()"
            />
          </div>
        }

        @if (authorisationModel.meetingAddressType !== undefined && authorisationModel.meetingAddressType !== MeetingLocationTypeEnum.Online && authorisationModel.meetingAddressType !== MeetingLocationTypeEnum.Phone) {
          <div class="address">
            <app-address-form-group
              [formGroup]="form.controls.address"
              [label]="MeetingLocationTypeEnum[authorisationModel.meetingAddressType] + ' Address'"
              [expandedAddressForm]="expandedAddressForm"
              [addressStatus]="addressStatus"
              [isDisabled]="authorisationModel.meetingAddressType !== MeetingLocationTypeEnum.Other"
              (onDataStatusChange)="onDataStatusChange($event)"
            />
          </div>
        }

        @if (getOfficers(false, false).length) {
          <div class="attendees">
            <app-list-grid-client-side
              [rowSelection]="attendeesRowSelection"
              [rowData]="attendeesList"
              [colDefs]="$any(colDefs)"
              [suppressRowClickSelection]="true"
              [suppressCellFocus]="true"
              [pagination]="false"
              [paginationPageSizeSelector]="false"
              (gridReady)="onGridReady($event)"
            />
          </div>

          <div class="drop-down-group-container">
            <div class="drop-down-container">
              <div class="form-group">
                <app-select
                  label="Chairperson"
                  placeholder="Select Chairperson"
                  [valuePrimitive]="true"
                  [options]="chairOptions"
                  [ngModelOptions]="{standalone: true}"
                  [(ngModel)]="authorisationModel.chairperson!.relationshipId"
                  (ngModelChange)="onChairPersonSelect($event)"
                />
              </div>

              @if (showChairpersonCheckbox) {
                <div class="form-group">
                  <app-checkbox
                    label="Set chairperson as signing officer"
                    [value]="setChairPersonAsSigningOfficer"
                    (change)="onSetChairPersonxChange($event)"
                  />
                </div>
              }
            </div>
          </div>
        }
      }
      <div [formGroup]="form" class="drop-down-container">
        <div class="form-group">
          <app-select
            formControlName="partnerManager"
            label="Partner Name"
            placeholder="Select Partner Name"
            [valuePrimitive]="true"
            [(ngModel)]="authorisationModel.partnerManagerId"
            [options]="partnerManagerOptions"
          />
        </div>
        @if(company.partnerManagerId != authorisationModel.partnerManagerId){
          <div class="mb-4">
          <app-checkbox
              label="Appoint selected Partner Manager as new or replace existing"
              [value]="setParnerManagerToCompany"
              (change)="onSetParnerManagerChange($event)"
            />
          </div>
        }
      </div>
    </div>
  }@else {
    <div class="skeleton-container">
      <ngx-skeleton-loader count="2" appearance="line" />
      <div class="d-flex gap-24">
        <ngx-skeleton-loader style="width: 50%" count="1" appearance="line" />
        <ngx-skeleton-loader style="width: 50%" count="1" appearance="line" />
      </div>
      <ngx-skeleton-loader count="2" appearance="line" />
      <div class="d-flex gap-24">
        <ngx-skeleton-loader style="width: 50%" count="1" appearance="line" />
        <ngx-skeleton-loader style="width: 50%" count="1" appearance="line" />
      </div>
      <ngx-skeleton-loader count="2" appearance="line" />
    </div>
  }
</div>
